import React, { useState, useCallback, useRef } from 'react';

import { UbiArticlePage } from 'utils/ubi/pages/useUbiArticle';

import useCallbackOnIdle from '../../hooks/useCallbackOnIdle';
import useCallbackOnExitIntent from '../../hooks/useCallbackOnExitIntent';
import useIsReached from '../../hooks/useIsReached';

import FeedbackDialog from './FeedbackDialog';

interface FeedbackPopUpProps {
  ubi: UbiArticlePage;
  articleIdentifier: string;
}

const FeedbackPopUp = ({ ubi, articleIdentifier }: FeedbackPopUpProps) => {
  const [hasDialogOpen, setHasDialogOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  // set isReached true when reach the anchor
  const anchorRef = useRef<HTMLDivElement>(null);
  const isReached = useIsReached({ anchorRef });

  // open dialog handler
  const shouldOpenDialog = useCallback(() => {
    setHasDialogOpen(true);
    setIsOpen(true);
  }, []);

  // open dialog on idle when isReached true
  useCallbackOnIdle({
    time: 20 * 1000, // 20 seconds
    callback: shouldOpenDialog,
    enabled: isReached && !hasDialogOpen,
  });

  // open dialog on exit intent when isReached true
  useCallbackOnExitIntent({
    callback: shouldOpenDialog,
    enabled: isReached && !hasDialogOpen,
  });

  return (
    <div data-testid="helpfulness-popup-anchor" ref={anchorRef}>
      {isOpen ? (
        <FeedbackDialog ubi={ubi} articleIdentifier={articleIdentifier} onClose={() => setIsOpen(false)} />
      ) : null}
    </div>
  );
};

export default FeedbackPopUp;
